import toast from 'react-hot-toast';
import useWhatsappStore from '~/store/whatsappStore';
import api2 from '../services/api2';
import { getDeliveryText } from './getDeliveryText';

const fila = [];

let isProcessing = false;

function timeProcess(min, max) {
  const timeout = Math.floor(Math.random() * (max - min + 1)) + min;

  return new Promise((resolve) => setTimeout(resolve, timeout));
}

export async function handleNotifyWhatsapp(
  item,
  orders,
  user,
  status,
  ifood_on_demand_id = null
) {
  if (item?.table?.table_type === 'delivery') {
    const userPhone =
      status === 'motoboy' ? item?.motoboy?.phone : item?.buyer?.phone;

    const textWpp = getDeliveryText(
      status,
      orders,
      item,
      user,
      ifood_on_demand_id
    );

    // Only send motoboy messages via backend, others are handled manually or removed
    if (status === 'motoboy') {
      const textSent = await api2.post(
        '/restaurants/whatsapp/send/message/motoboy',
        {
          token: user.id,
          session_id: item?.session_id,
          phone: userPhone,
          text: textWpp,
        }
      );
      if (textSent.data.status === 400 || textSent.data.status === 503) {
        if (textSent.data.status === 503) {
          toast.error(textSent.data.message, { duration: 5000 });
        } else {
          const sanitizedText = textWpp
            .replace(/\n/g, '%0a')
            .replace(/&/g, '%26')
            .replace(/#/g, '%23');
          useWhatsappStore.getState().setWppFailedMessage({
            phone: userPhone,
            text: sanitizedText,
          });
        }
      } else {
        toast.success(
          'Whatsapp com informações do pedido enviado para motoboy'
        );
      }
    }
  }
}

async function processQueue() {
  if (isProcessing) return;
  isProcessing = true;

  while (fila.length > 0) {
    const atual = fila.shift();

    try {
      // eslint-disable-next-line no-await-in-loop
      await handleNotifyWhatsapp(
        atual.item,
        atual.orders,
        atual.user,
        atual.status,
        atual.ifood_on_demand_id
      );
    } catch (error) {
      console.log('Erro ao enviar notificação WhatsApp:', error);
    }

    // eslint-disable-next-line no-await-in-loop
    await timeProcess(10000, 15000);
  }

  isProcessing = false;
}

export function addMessageWhatsapp(dados) {
  fila.push(dados);
  processQueue();
}
